import {authorized} from "./ApiClient";
import {LicenseBindingModel, LicenseViewModel, NewLicenseBindingModel} from "./models";

const license = (id: string) => `/license/${encodeURIComponent(id)}`;

// License administration, for every product (SiteAdmin).
export const LicensesApi = {
    getAll: () => authorized<LicenseViewModel[]>('GET', '/license'),

    // Without a key, the API generates one.
    create: (model: NewLicenseBindingModel) => authorized<LicenseViewModel>('POST', '/license', model),

    get: (id: string) => authorized<LicenseViewModel>('GET', license(id)),

    update: (id: string, model: LicenseBindingModel) => authorized<LicenseViewModel>('PUT', license(id), model),

    freeSeat: (id: string, activationId: string) =>
        authorized<void>('DELETE', `${license(id)}/activation/${encodeURIComponent(activationId)}`),

    // Clears the yearly count of new activations (seats stay as they are). Returns the license.
    resetActivationCount: (id: string) => authorized<LicenseViewModel>('DELETE', `${license(id)}/activation-count`),

    // A review license: extend gives it another 30 days, keep keeps it for good. 409 not_a_review_license.
    review: (id: string, action: 'extend' | 'keep') => authorized<LicenseViewModel>('POST', `${license(id)}/review`, { action })
};
